// extracted by mini-css-extract-plugin
export default {"loading":"loading-loading-DrxW0I","pulse":"loading-pulse-qQUU7m","dot-flashing":"loading-dot-flashing-RpQoHP","dark":"loading-dark-_xGHw1"};